import * as React from 'react';

import { useDocumentLanguage } from '@hooks/useDocumentLanguage';

import { BrandPanel } from './BrandPanel';
import { LanguageToggle } from './LanguageToggle';

/**
 * Type A split layout: the navy BrandPanel beside a centered form pane. The
 * pane carries the dark-mode glow, the mobile-only logo, and the language
 * switcher; `children` is the page's form. Unauthenticated routes never mount
 * MainLayout, so <html lang> is corrected here too.
 */
export function AuthShell({ children }: { children: React.ReactNode }) {
  useDocumentLanguage();

  return (
    <div
      data-auth-shell="split"
      data-testid="auth-shell"
      className="grid min-h-screen min-h-dvh lg:grid-cols-[1.05fr_1fr]"
    >
      <BrandPanel />

      <main
        data-auth-pane="right"
        className="revy-cjk relative flex min-h-screen min-h-dvh min-w-0 flex-col justify-center overflow-x-hidden overflow-y-auto bg-background px-5 py-16 sm:px-8"
      >
        <div className="pointer-events-none absolute inset-0 hidden dark:block">
          <div className="absolute left-1/2 top-1/2 h-[34rem] w-[34rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,hsl(212_100%_55%/0.09),transparent_60%)] blur-2xl" />
        </div>

        <div className="absolute right-5 top-5 z-10">
          <LanguageToggle />
        </div>

        <div className="mb-8 flex items-center gap-2.5 lg:hidden">
          <span className="text-base font-bold tracking-tight text-foreground">
            REVY
          </span>
        </div>

        <div
          data-auth-content="form"
          data-testid="auth-content"
          className="relative mx-auto w-full max-w-[400px] animate-fade-up motion-reduce:animate-none"
        >
          {children}
        </div>
      </main>
    </div>
  );
}
